import React from 'react';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import accents from '../../appointment/components/moduleCard/accents.module.css';
import styles from './stats.module.css';
import { formatNumber, formatValue } from '../utils/format';
import { useStatsCompare } from './compareContext';
import { useStatsPrint } from './printContext';

/**
 * Variação contra o período anterior. `inverse`: quando cair é bom (faltas,
 * despesas). `unit = 'points'`: diferença em pontos (NPS), não em %.
 */
export function DeltaBadge({ change, inverse = false, unit }) {
  if (change === null || change === undefined) return null;
  const rounded = Math.round(change * 10) / 10;
  if (rounded === 0) {
    return <span className={`${styles.delta} ${styles.deltaNeutral}`}>igual</span>;
  }
  const up = rounded > 0;
  const good = inverse ? !up : up;
  const text = unit === 'points'
    ? `${formatNumber(Math.abs(rounded))} pts`
    : `${formatNumber(Math.abs(rounded), 1)}%`;
  return (
    <span className={`${styles.delta} ${good ? styles.deltaGood : styles.deltaBad}`}>
      {up ? <ArrowUpwardRoundedIcon /> : <ArrowDownwardRoundedIcon />}
      {text}
    </span>
  );
}

/**
 * Indicador com ícone, valor e, quando a tela compara, a variação contra o
 * período comparado (anterior ou o mesmo do ano passado).
 * `kpi`: { value, previous, change, unit? } vindo da API.
 * `type`: number | money | percent | decimal | days.
 * `help`: o que o número conta, num (i) ao lado do rótulo (fora do PDF).
 */
const StatCard = ({ icon, label, kpi, type = 'number', inverse = false, accent = 'blue', hint, help }) => {
  const compare = useStatsCompare();
  const print = useStatsPrint();
  const value = kpi ? kpi.value : null;
  const hasPrevious = compare.enabled && kpi && kpi.previous !== null && kpi.previous !== undefined;

  return (
    <div className={`${styles.stat} ${accents[accent] || accents.blue}`}>
      <div className={styles.statTop}>
        {icon && <span className={styles.statIcon}>{icon}</span>}
        <span>{label}</span>
        {help && !print && (
          <Tooltip title={help} arrow>
            <span className={styles.statHelp} aria-label={help}>
              <InfoOutlinedIcon />
            </span>
          </Tooltip>
        )}
      </div>
      <div className={styles.statValue}>{formatValue(value, type)}</div>
      <div className={styles.statFoot}>
        {compare.enabled && kpi && <DeltaBadge change={kpi.change} inverse={inverse} unit={kpi.unit} />}
        {hint || (hasPrevious ? `${compare.before}: ${formatValue(kpi.previous, type)}` : '')}
      </div>
    </div>
  );
};

export default StatCard;
